import React, { useEffect, useState } from "react";
import { isAuthenticated } from "../../services/auth.service";
import { useNavigate } from "react-router";
import ProfilePage from "./ProfilePage";

const ProfileContainer = () => {
    const [isAuth] = useState(isAuthenticated());
    const navigate = useNavigate();
    useEffect(() => {
        !isAuth && navigate("/login");
    });
    return (
        <div>
            <ProfilePage />
        </div>
    );
};

export default ProfileContainer;
